<template>
  <f7-page no-toolbar no-swipeback name="" class="page">
    <f7-navbar :title="$t('referrer_share_0001')" back-link :no-hariline="true"></f7-navbar>
    <f7-block class="block">
      <f7-tabs>
        <f7-tab id="tab-share" class="page-content" tab-active>
          <div class="share">
            <div class="url text-center">{{ $t("referrer_share_0002") }}</div>
            <div class="code text-center" id="qrcode"></div>
            <div class="url text-center">{{ $t("referral_v1_001") }}</div>
            <div class="promo text-center">{{ promoCode }}</div>
            <div class="list inset button-share">
              <ul>
                <li>
                  <a href="#" class="list-button color-black" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ $t("referrer_share_0003") }}</a>
                </li>
              </ul>
            </div>
            <div class="tips-desc">
              <p>{{ $t("common_0004") }}：</p>
              <p>{{ $t("referrer_share_0004") }}</p>
              <!-- <p>{{ $t('referrer_share_0005') }}</p> -->
            </div>
          </div>
        </f7-tab>
      </f7-tabs>
    </f7-block>
  </f7-page>
</template>

<script>
import QRCode from "qrcodejs2";
import api from "../../../config/api";
import { getCookie, setCookie, getStore, setStore } from "../../../config/utils";

export default {
  components: { QRCode },
  props: {},
  data() {
    return {
      link: "https://baidu.com",
      verifyUrl: ``,
      promoCode: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    //  生成二维码
    qrcode() {
      let self = this;
      this.link = window.location.protocol + "//" + window.location.host + "/#/register/" + "?d=" + getCookie("p");
      let qrcode = new QRCode("qrcode", {
        width: 124,
        height: 124, // 高度
        text: this.link, // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },
    onCopy(e) {
      const self = this;
      if (e.text) {
        let copyLoading = self.$f7.dialog
          .create({
            title: "",
            text: this.$t("common_0003"),
            cssClass: "dialog-preloadgame",
          })
          .open();

        setTimeout(() => {
          copyLoading.close();
        }, 1000);
      }
    },
    onError(e) {
      console.log(e);
    },
    updateVerify() {
      const uid = common.uuid();
      setCookie("u", uid, 7);
      this.verifyUrl = `${api.verifyimage}?u=${uid}`;
    },
  },
  created() {
    this.verifyUrl = `${api.verifyimage}?u=${getCookie(`u`)}`;
    this.promoCode = getCookie("p");
  },
  mounted() {
    this.qrcode();
  },
};
</script>
<style lang="less" scoped>
.head {
  width: 100%;
  padding-right: 54px;
}
.nav {
  display: table;
  // display: table;
  margin: 0 auto;
  a {
    display: inline;
  }
  p {
    background: #3965b9;
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    float: left;
    margin: 0;
    a {
      display: block;
      color: #fff;
    }
  }
  .tab-link-active {
    p {
      background: #0d3a92;
    }
  }
  .lef {
    border-right: 1px solid #0c3ca2;
    border-radius: 30px 0 0 30px;
  }
  .rig {
    border-right: 1px solid #0c3ca2;
    border-radius: 0 30px 30px 0;
  }
}

.page {
  .page-content {
    padding: 0px;
  }
  .share {
    .url {
      color: #0a0000;
      font-size: 15px;
    }
    .promo {
      color: #53659b;
      font-weight: bold;
      font-size: 15px;
    }
    .code {
      width: 125px;
      height: 125px;
      background: #fff;
      padding: 5px;
      margin: auto;
      border: 1px solid #000;
      border-radius: 2px;
    }
    div {
      margin-bottom: 10px !important;
    }
    .tips-desc {
      margin-left: 10px;
      margin-bottom: 4px;
    }
  }
  .register {
    .list {
      margin: var(--f7-margin-size-10) 0;
      .block-title {
        background: url(../../../static/images/yt999/register_title.png) no-repeat;
        width: var(--f7-px-100);
        height: var(--f7-height-size-30);
        line-height: var(--f7-height-size-30);
        background-size: cover;
        color: #000432;
        margin-left: var(--f7-size-ps-12);
        margin-bottom: var(--f7-margin-size-0);
        margin-top: var(--f7-margin-size-15);
        padding-left: var(--f7-px-5);
        font-size: var(--f7-font-size-14);
      }
      ul {
        background-color: var(--f7-color-bg-transparent);
        .item-content {
          margin-bottom: var(--f7-margin-size-10);
          padding-left: var(--f7-px-20);

          input {
            font-size: var(--f7-font-size-14);
            color: var(--f7-color-white);
          }

          .input-clear-button {
            right: var(--f7-size-ps-12);
          }

          .iconfont {
            color: var(--f7-color-white);
          }
          .span-verify {
            position: var(--f7-postion-absolute);
            right: var(--f7-px-10);
            top: var(--f7-px-4);
            z-index: 2;
          }
        }
      }
      ul:before,
      ul:after {
        height: 0;
      }
    }
    .list .item-inner:after {
      width: var(--f7-width-size-pt92);
    }

    .list li:last-child > .item-inner:after {
      display: var(--f7-display-block) !important;
    }

    .block-strong {
      padding: var(--f7-padding-size-10) var(--f7-padding-size-20, --f7-block-padding-horizontal);
      margin: var(--f7-margin-size-0) auto;
      .block-header {
        margin-bottom: var(--f7-margin-size-15);
      }
      .block-footer {
        margin-top: var(--f7-margin-size-15);
        a.link {
          border-bottom: 1px solid var(--f7-color-lightblue);
        }
      }
    }
    .block-strong:before,
    .block-strong:after {
      height: var(--f7-height-size-0);
    }
  }
  .button-share {
    margin: 10px 12px;
    ul {
      background: #b19785;
    }
    .list-button {
      background-color: var(--f7-THEME-color);
      color: #fff;
    }
    ul {
      background: var(--f7-button-bg-color);
      li {
        a {
          color: #fff;
        }
      }
    }
  }
}
</style>
